import React, { useEffect, useMemo, useState } from 'react';

import '../styles/styles.css';
import '../styles/formularios.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import logoInstituto from "../components/images/logo.png";
import logoSEP from "../components/images/SEP_Logo_2019.png";
import { useLocation, useNavigate } from 'react-router-dom';

const ConsultarCategoria = () => {
  const navigate = useNavigate();
    const location = useLocation();
    const handleSalir = () => {
      const rol = resolveRolBase(location.pathname);
      if (rol) {
        navigate(`/${rol}/inicio`, { replace: true });
      } else {
        // Fallback por si no se detecta rol ni en path ni en localStorage:
        navigate('/inicio', { replace: true });
      }
    };
    
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  const apiBases = useMemo(() => {
    const list = [];
    const seen = new Set();

    const pushBase = (value) => {
      if (!value) return;
      const normalized = value.replace(/\/$/, '');
      if (!seen.has(normalized)) {
        seen.add(normalized);
        list.push(normalized);
      }
    };

    const pushVariants = (value, { includeRaw = false } = {}) => {
      if (!value) return;
      const trimmed = value.replace(/\/$/, '');
      if (includeRaw) pushBase(trimmed);
      pushBase(`${trimmed}/api`);
      pushBase(`${trimmed}/backend`);
    };

    const envBase = process.env.REACT_APP_API_BASE?.trim();
    if (envBase) pushVariants(envBase, { includeRaw: true });

    if (typeof window !== 'undefined') {
      const { origin } = window.location;
      pushVariants(origin);
      pushVariants('https://institutosilvianocarrillo.com');
      pushVariants('https://www.institutosilvianocarrillo.com');
    }

    pushBase('/api');
    pushBase('/backend');

    return list.map((base) => `${base}/categorias`);
  }, []);

  useEffect(() => {
    const cargarCategorias = async () => {
      try {
        let lastError = null;
        for (const base of apiBases) {
          const url = `${base}/consultar`;
          try {
            const res = await fetch(url);
            const text = await res.text();

            if (!res.ok) {
              lastError = new Error(text || `Error ${res.status}`);
              lastError.status = res.status;
              console.warn(`⚠️ Falló la petición a ${url}:`, lastError);
              continue;
            }

            const contentType = res.headers.get('content-type') || '';
            const trimmed = text.trim();
            if (!trimmed) {
              setCategorias([]);
              return;
            }

            if (contentType.includes('application/json') || trimmed.startsWith('{') || trimmed.startsWith('[')) {
              const data = JSON.parse(trimmed);
              const arr = Array.isArray(data) ? data : data?.data;
              setCategorias(Array.isArray(arr) ? arr : []);
              return;
            }

            lastError = new Error(`Respuesta inválida desde ${url}`);
            console.warn(`⚠️ Contenido no JSON desde ${url} (content-type: ${contentType || 'desconocido'})`);
          } catch (error) {
            lastError = error;
            console.warn(`⚠️ Error de red al solicitar ${url}:`, error);
          }
        }

        throw lastError || new Error('No se pudieron cargar las categorías');
      } catch (e) {
        setErr('No se pudieron cargar las categorías');
      } finally {
        setLoading(false);
      }
    };

    cargarCategorias();
  }, [apiBases]);

  return (
    <div className="container py-4 px-4">
      {/* Encabezado con logos */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <img src={logoInstituto} alt="Logo Instituto" className="logo" />
        <div className="flex-grow-1 text-center">
          <h4 className="mb-0">Instituto Silviano Carrillo</h4>
          <small className="text-muted fs-5">Consultar Categoría de Materia</small>
        </div>
        <img src={logoSEP} alt="Logo SEP" className="logo" />
      </div>


      {/* Alertas */}
      {err && (
        <div className="alert alert-danger py-2" role="alert">
          {err}
        </div>
      )}

      {/* Tabla de categorías */}
      <div className="table-responsive mt-4">
        <table className="table table-bordered table-hover shadow-sm bg-white text-center">
          <thead className="table-light">
            <tr>
              <th>ID</th>
              <th>Descripción</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={2} className="text-muted">
                  Cargando...
                </td>
              </tr>
            ) : categorias.length === 0 ? (
              <tr>
                <td colSpan={2} className="text-muted">
                  Sin registros
                </td>
              </tr>
            ) : (
              categorias.map((c) => (
                <tr key={c.IdCategoriaMateria ?? c.ID}>
                  <td>{c.IdCategoriaMateria ?? c.ID}</td>
                  <td>{c.Descripcion}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Botón Salir */}
      <div className="mt-4 text-center">
        <button type="button" className="btn btn-danger px-4" onClick={handleSalir}>
             Salir
        </button>
      </div>
    </div>
  );
};
/* ----------------- Helper para detectar el rol ----------------- */
function resolveRolBase(pathname) {
  // 1) Intenta desde la URL actual
  const roles = ['directora', 'coordinadora', 'docente', 'alumno'];
  const seg = pathname.split('/').filter(Boolean)[0];
  if (roles.includes(seg)) return seg;

  // 2) Respaldo desde localStorage.role (números mapeados a slugs)
  const roleId = Number(localStorage.getItem('role'));
  const map = { 1: 'directora', 2: 'coordinadora', 3: 'docente', 4: 'alumno' };
  return map[roleId] || null;
}


export default ConsultarCategoria;
